import { Pipe, PipeTransform } from '@angular/core';
import { StorageService } from 'src/app/core/services/storage.service';

/*
 * Price of a track sold on its own, for its Buy button (new and classic album page). Display only:
 * the ticket is picked exactly as ic-media-payment picks it (the paid ticket whose sessions include the
 * track), and the currency as it labels it, so the label always matches what the payment panel charges.
 */

export function trackTicket(element: any, tickets: any[]): any | null {
  const id = Number(element?.stream_info?.id ?? element?.id);
  if (!id || !Array.isArray(tickets)) return null;
  return tickets.find(t => t?.ticket_type == 'paid' && Array.isArray(t.sessions) && t.sessions.some((s: any) => Number(s) === id)) || null;
}

/** "$1.00" (or "USD 1.00" when the browser has no symbol); '' when the track has no paid ticket with a price. */
export function trackPriceLabel(element: any, tickets: any[], preferredCurrency?: string | null): string {
  const ticket = trackTicket(element, tickets);
  const amount = Number(ticket?.price);
  if (!(amount > 0)) return '';
  const currency = preferredCurrency || ticket.original_currency || ticket.currency || '';
  try {
    if (currency) return new Intl.NumberFormat('en', { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).format(amount);
  } catch {
    // Unknown currency code: plain text below.
  }
  return `${currency} ${amount.toFixed(2)}`.trim();
}

/** `element | vdTrackPrice: tickets` — the fan's selected currency is read like ic-media-payment does. */
@Pipe({ name: 'vdTrackPrice' })
export class VdTrackPricePipe implements PipeTransform {
  constructor(private storage: StorageService) {}

  transform(element: any, tickets: any[]): string {
    return trackPriceLabel(element, tickets, this.storage.getItem('currency'));
  }
}
